/**
 * CSV export utilities. All values are quoted and escaped; Italian locale
 * (semicolon separator) used so Excel opens the file correctly by default.
 */

const escape = (val) => {
  if (val === null || val === undefined) return "";
  const s = String(val);
  // Always wrap in quotes; escape internal quotes
  return `"${s.replace(/"/g, '""')}"`;
};

/**
 * exportCsv({ filename, headers, rows, delimiter?: ";" })
 *   headers: string[]
 *   rows: Array<Array<any>>
 */
export const exportCsv = ({ filename, headers, rows, delimiter = ";" }) => {
  const lines = [headers.map(escape).join(delimiter)];
  for (const row of rows) {
    lines.push(row.map(escape).join(delimiter));
  }
  // UTF-8 BOM so Excel detects the encoding correctly on Windows
  const csv = "\uFEFF" + lines.join("\r\n");
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename.endsWith(".csv") ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 500);
};
